import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, ReplaySubject} from 'rxjs';
import {first, take} from 'rxjs/operators';
import {Uuid} from '../interface/response/uuid';
import {FilterService} from './filter.service';
import {CountedAndPaginated} from '../interface/response/counted-and-paginated';
import {PersonalDataChange} from '../interface/personalDataChange';
import {ListResponse} from "../interface/response/list-response";
import {Document as DocumentInterface} from "../interface/document";
import {Dictionary} from "../interface/dictionary";


@Injectable({
  providedIn: 'root'
})
export class PersonalDataChangeService {
  private readonly personalDataChangeListSubject: ReplaySubject<CountedAndPaginated<PersonalDataChange>>
    = new ReplaySubject<CountedAndPaginated<PersonalDataChange>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
  ) { }

  public loadList(page: number, pageSize: number, filters: object, sort?: { sortBy?: string; sortOrder?: string }): void {
    const sortBy = sort?.sortBy || 'dateOfSubmission';
    const sortOrder = sort?.sortOrder || 'DESC';
    this.httpClient.get(`/rest/crm/personalDataChange?page=${page + 1}&pageSize=${pageSize}&sortBy=${sortBy}&sortOrder=${sortOrder}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<PersonalDataChange>) => {
        this.personalDataChangeListSubject.next(result);
      });
  }

  public downloadReport(filters: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/personalDataChange/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  public delete(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/personalDataChange/${uuid}`)
      .pipe(first());
  }

  public get(personalDataChangeId: string): Observable<PersonalDataChange> {
    return this.httpClient.get(`/rest/crm/personalDataChange/${personalDataChangeId}`)
      .pipe(first()) as Observable<PersonalDataChange>;
  }

  public getPersonalDataChangeListSubject(): ReplaySubject<CountedAndPaginated<PersonalDataChange>> {
    return this.personalDataChangeListSubject;
  }

  public getPersonalDataChangeDocuments(personalDataChangeId: string): Observable<ListResponse<DocumentInterface>> {
    return this.httpClient.get(`/rest/crm/personalDataChange/${personalDataChangeId}/document`)
      .pipe(first()) as Observable<ListResponse<DocumentInterface>>;
  }

  public updateStatus(formData: Dictionary, personalDataChangeId: string): Observable<any> {
    return this.httpClient.put(`/rest/crm/personalDataChange/${personalDataChangeId}/changeStatusToCompleted`, formData)
      .pipe(first());
  }

}
